"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m21.76 0h-19.52a.56.56 0 0 0 -.63.64v19.51a.56.56 0 0 0 .63.64h6.39l3.21 3.15a.24.24 0 0 0 .32 0l3.21-3.15h6.39a.56.56 0 0 0 .63-.64v-19.51a.56.56 0 0 0 -.63-.64z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m16.34 7-2.92 2.93v1.38l3-3v-1.17a.24.24 0 0 0 -.08-.14z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m13.42 13.54 2.97-2.97v-1.38l-2.97 2.96z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m13.42 15.85 2.97-2.96v-1.38l-2.97 2.95z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m16.09 16.52a.3.3 0 0 0 .3-.29v-2.23l-2.55 2.54z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m13.42 9.09 2.24-2.24h-1.83c-.39 0-.41.43-.41.43v.07h-7a.44.44 0 0 0 -.44.44.44.44 0 0 0 .44.44h7.05z"
  })));
};

exports["default"] = _default;